import React, { FC } from 'react'
import s from './GigAssist.module.sass'
import { Template } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import TypeAndPrice from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice/TypeAndPrice'
import { Place } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/Place'
import { ScheduleAndPrice } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/ScheduleAndPrice'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'
import { Text } from '@shared/ui/Typography/Text'

const GigAssist: FC<
  TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = (props) => {
  const [size] = useCurrentSize(props.sizes)

  const price = props.data.price || { level: null, tag: { url: '' } }
  const metro = props.data.address?.metro || null
  const address = props.data.address?.address || ''
  const discounts = props.data.discounts || { remarked: null, restoplace: null, tastyclub: null }
  const schedule = props.data.schedule || null

  return (
    <ErrorBoundary>
      <Template {...props} className={`${props.className || ''} ${s.card}`}>
        {!!discounts.remarked && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{discounts.remarked}₽
          </PromoBadgeLabel>
        )}

        {!!discounts.restoplace && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{discounts.restoplace}₽
          </PromoBadgeLabel>
        )}

        <TypeAndPrice
          restType={props.data.type || ''}
          tag={props.data?.tags?.main_tag || null}
          priceRange={price.level}
          priceLink={price.tag?.url || ''}
        />

        <Place address={address} metro={metro} />

        <ScheduleAndPrice schedule={schedule} />

        {props.additionalData?.conclusion && (
          <Text sizes={'S'} className={s.conclusion}>
            {props.additionalData?.conclusion}
          </Text>
        )}
      </Template>
    </ErrorBoundary>
  )
}

export default GigAssist
